import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import {
	adminGetAllCampaigns,
	resetFocusCampaign,
	adminGetCampaignById,
	initNewCampaign,
	adminPostCampaign,
	adminPatchCampaign,
	adminDeleteCampaign,
	getCampaignFileCsvToJson,
	getCsvTemplate,
	loadListRecords,
	getCampaignExport,
} from "services/campaign";
import { searchCompanies } from "services/company";
import { adminGetAllCenters } from "services/center";
import { searchDoctors } from "services/doctor";
import { adminGetAnalysesPacksForCampaigns } from "services/analysesPack";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/Campagnes/Forms/GeneralForm";
import CampaignRecords from "features/Admin/Campagnes/Forms/CampaignRecords";
import UploadCampaignFile from "features/Admin/Campagnes/Forms/UploadCampaignFile";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import * as Yup from "yup";
import debounce from "lodash.debounce";
import Papa from "papaparse";
import { getDoctorExists } from "services/doctor";
import { isJson } from "utils/json";

const schemaValidation = Yup.object().shape({
	name: Yup.string().required("Champ requis"),
});

class Campagnes extends Component {
	constructor(props) {
		super(props);

		this.state = {
			doctors: [],
			doctorLoading: false,
			companies: [],
			companiesLoading: false,
			centersFactory: {
				list: this.props.centers.list,
				listLabel: "Sélectionner un ou plusieurs centres",
				selectedLabel: "Centres qui prennent en charge les patients de cette campagne",
				value: [],
			},
		};
	}
	updateFactoryValue = (newSelected, name) => {
		this.setState((prevState) => ({
			...prevState,
			[name]: {
				...prevState[name],
				value: newSelected,
			},
		}));
	};

	setupFactories = (elt) => {
		this.setState({
			centersFactory: {
				list: this.props.centers.list
					.filter((c) => c.isCenter)
					.map((i) => {
						return { ...i };
					}),
				listLabel: this.state.centersFactory.listLabel,
				selectedLabel: this.state.centersFactory.selectedLabel,
				value: elt.limitedCenters,
			},
		});
	};

	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusCampaign();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = async () => {
		this.props.adminGetAllCenters();
		this.props.adminGetAllCampaigns();
		this.props.adminGetAnalysesPacksForCampaigns();
		if (this.props.campaigns?.focus && this.props.campaigns.focus.data && this.props.campaigns.focus.data.limitedCenters !== undefined)
			this.setupFactories({
				limitedCenters: this.props.centers.list
					.filter((c) => c.isCenter)
					.filter(
						(c) =>
							this.props.campaigns.focus.data.limitedCenters && this.props.campaigns.focus.data.limitedCenters.split(",").includes(c.id.toString())
					)
					.map((c) => JSON.stringify(c)),
			});
	};

	focusOnElement = (elt) => {
		this.props.adminGetCampaignById(elt.id);
	};

	onAddClick = () => {
		this.props.initNewCampaign();
	};

	saveFocus = (values, setSubmitting) => {
		values.limitedCenters = this.state.centersFactory.value
			.filter((c) => isJson(c))
			.map((c) => JSON.parse(c).id)
			.join(",");
		if (values.prescriber) this.createOrUpdateDoctor(values.prescriber);
		if (values.carbonCopyDoctors && values.carbonCopyDoctors.length > 0) {
			for (let i = 0; i < values.carbonCopyDoctors.length; i++) {
				this.createOrUpdateDoctor(values.carbonCopyDoctors[i].doctor);
			}
		}
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPatchCampaign(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPostCampaign(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	createOrUpdateDoctor = async (myLabDoctor) => {
		const localDoctor = { ...myLabDoctor.address, ...myLabDoctor };
		localDoctor.code = localDoctor.provider_code;
		// @see NURSE-341 `doctors.exists` is populated by this method at reducer stage
		// @see reducers/doctor.js
		await this.props.getDoctorExists(localDoctor.mylab_id);
		//console.debug( "localDoctor POST/PATCH", localDoctor, this.props.doctors.exists );
		// The MYLAB doctor does not exist on NURSE
		if (this.props.doctors.exists === 0) {
			localDoctor.id = null; // Make sure it is null
			// @see NURSE-341 `doctors.doctor` is populated by this method at reducer stage
			// @see reducers/doctor.js
			await this.props.postDoctor(localDoctor);
			// With possible failure
			if (this.props.doctors.doctor) localDoctor.id = this.props.doctors.doctor.id;
		} else {
			localDoctor.id = this.props.doctors.exists;
			//await this.props.patchDoctor(localDoctor);
			console.warn(
				"[NURSE-341#158] PATCH doctor is disabled now (NURSEID#" + localDoctor.id + "; MYLABID#" + localDoctor.mylab_id + ")",
				localDoctor
			);
		}
		return localDoctor;
	};

	deleteFocus = () => {
		this.props.adminDeleteCampaign(this.props.boxes.focus.data.id);
	};

	filterDoctors = debounce((searchTerm, callback) => {
		this.props
			.searchDoctors({ multiple_search: searchTerm }, 30, 0)
			.then(() =>
				callback(
					this.props.doctors.list
						? this.props.doctors.list.map((doctor) => {
								return {
									value: doctor.id,
									label: `${doctor.code} - ${doctor.last_name} ${doctor.first_name} - ${doctor.speciality} - ${doctor.address.street} ${doctor.address.postal_code} ${doctor.address.city}`,
									labels: [
										{ text: doctor.code, width: 10 },
										{ text: doctor.last_name, width: 20 },
										{ text: doctor.first_name, width: 20 },
										{ text: doctor.speciality, width: 10 },
										{ text: doctor.address?.street, width: 20 },
										{ text: doctor.address?.postal_code, width: 5 },
										{ text: doctor.address?.city, width: 15 },
									],
									...doctor,
									sil_id: doctor.external_id,
									mylab_id: doctor.id,
								};
						  })
						: []
				)
			)
			.catch((error) => {
				callback(error);
			});
	}, 500);

	filterCompany = debounce((searchTerm, callback) => {
		this.props
			.searchCompanies({ name: searchTerm }, 20, 0)
			.then((res) => {
				callback(
					this.props.companies.list
						? this.props.companies.list.map((company) => {
								return {
									id: company.id,
									value: company.id,
									label: `${company.type ? `${company.type} - ` : ""} ${company.name} ${company.department ? ` - ${company.department}` : ""}`,
									...company,
									isDisabled: this.props.access_companies ? this.props.access_companies.filter((ac) => ac.id === company.id).length === 0 : false,
								};
						  })
						: []
				);
			})
			.catch((error) => {
				callback(error);
			});
	}, 500);

	convertAction = (e) => {
		const csvContent = e.target.files[0];
		//convert csv to json and send data to serveur for save in a file
		Papa.parse(csvContent, {
			header: true,
			skipEmptyLines: true,
			complete: (result) => {
				let jsonData = result.data;
				this.props.getCampaignFileCsvToJson(jsonData, this.props.campaigns.focus.data.id).then((res) => {
					this.props.adminGetCampaignById(this.props.campaigns.focus.data.id);
				});
			},
		});
	};

	importCSV = () => {
		const input = document.createElement("input");
		input.type = "file";
		input.accept = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
		input.onchange = this.convertAction;
		input.click();
	};

	getStatusFolder = (folder) => {
		if (folder.is_temp) return "Temporaire";
		switch (folder.status) {
			case "PENDING":
			case "NEW":
			case "HELP_NURSE":
				return "En cours";
			case "DONE":
				return "Terminé";
			case "CANCELED":
				return "Annulé";
			default:
				return "";
		}
	};

	render() {
		const { campaigns } = this.props;
		const { focus, list } = campaigns;
		const campaign = focus.data;
		const newCampaign = campaign !== null && campaign.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={{ data: campaigns.list.data }}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="Campagnes de prélèvement"
					addButtonText="Nouvelle campagne"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.name}
					groupField="status"
					focusedEltId={campaign}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity="Campagnes"
					icon="info"
					actionsFunction={[
						async () => {
							await this.props.getCsvTemplate().then((res) => {
								const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.payload.data.base64}`;
								const downloadLink = document.createElement("a");
								const fileName = `template.csv`;
								downloadLink.href = linkSource;
								downloadLink.download = fileName;
								downloadLink.click();
							});
						},
					]}
					actionsButton={[
						<>
							<Icon name="download" />
							Récupérer le template
						</>,
					]}
					//importFunction={this.props.adminImportCenters}
				>
					{campaign !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: campaign.id,
								name: campaign.name || "",
								abbreviation: campaign.abbreviation || "",
								reference: campaign.reference || "",
								analyses_pack: campaign.analyses_pack ? campaign.analyses_pack.id : "",
								prescriber: campaign.prescriber
									? {
											id: campaign.prescriber.id,
											value: campaign.prescriber.mylab_id,
											label: `${campaign.prescriber.code || ""} ${campaign.prescriber.last_name || ""} ${campaign.prescriber.first_name || ""} - ${
												campaign.prescriber.specialty?.name || ""
											} - ${campaign.prescriber.number || ""} ${campaign.prescriber.street || ""} ${campaign.prescriber.postal_code || ""} ${
												campaign.prescriber.city || ""
											}`,
									  }
									: null,
								carbonCopyDoctors: campaign.carbonCopyDoctors
									? campaign.carbonCopyDoctors.map((cc) => {
											return {
												doctor: {
													value: cc.doctor.mylab_id,
													id: cc.doctor.id,
													label: `${cc.doctor.code || ""} ${cc.doctor.last_name || ""} ${cc.doctor.first_name || ""} - ${
														cc.doctor.specialty?.name || ""
													} - ${cc.doctor.number || ""} ${cc.doctor.street || ""} ${cc.doctor.postal_code || ""} ${cc.doctor.city || ""}`,
												},
												to_be_phoned: cc.to_be_phoned,
												to_be_phoned_number: cc.to_be_phoned_number,
												to_be_faxed: cc.to_be_faxed,
												to_be_faxed_number: cc.to_be_faxed_number,
											};
									  })
									: [],
								billing_company: campaign.billing_company
									? {
											id: campaign.billing_company.id,
											value: campaign.billing_company.id,
											label: `${campaign.billing_company.type ? `${campaign.billing_company.type} - ` : ""} ${campaign.billing_company.name} ${
												campaign.billing_company.department ? ` - ${campaign.billing_company.department}` : ""
											}`,
											...campaign.billing_company,
											isDisabled: false,
									  }
									: null,
								limitedCenters: campaign.limitedCenters || "",
								templateEmail: campaign.templateEmail || "",
								status: campaign.status === "ACTIVE" || false,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, handleSubmit, errors, values, disabled, handleChange, setFieldValue }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusCampaign}>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name="save" />}
													type="button"
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
													onClick={handleSubmit}
												>
													{newCampaign ? "Créer" : "Enregistrer"}
												</MainButton>

												{!newCampaign && (
													<RedButton
														text={<Icon name="trash" />}
														type="button"
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: "right" }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm
														errors={errors}
														packsCampaigns={campaigns.packs.data}
														values={values}
														setFieldValue={setFieldValue}
														disabled={disabled}
														handleChange={handleChange}
														filterCompany={this.filterCompany}
														filterDoctors={this.filterDoctors}
														updateCenters={(value) => this.updateFactoryValue(value, "centersFactory")}
														centersFactory={this.state.centersFactory}
													/>
													<AdminDataContainer ribbonColor="green" ribbonLabel="Téléchargement de patients">
														{values.id && (
															<UploadCampaignFile campaign={campaign} importCSV={this.importCSV} getCampaignExport={this.props.getCampaignExport} />
														)}
													</AdminDataContainer>
													<AdminDataContainer ribbonColor="teal" ribbonLabel="Patients concernés">
														{values.id && campaign.records && campaign.records.records && campaign.records.records.length > 0 && (
															<CampaignRecords
																campaign={campaign}
																records={campaign.records}
																getStatusFolder={this.getStatusFolder}
																loadListRecords={this.props.loadListRecords}
																currentPage={campaign.current}
																pages={campaign.total}
															/>
														)}
														{campaign.records && campaign.records.records && campaign.records.records.length === 0 && (
															<sapn>Pas de patients pour cette campagne</sapn>
														)}
													</AdminDataContainer>
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		campaigns: state.admin.campaigns,
		companies: state.companies,
		doctors: state.doctors,
		centers: state.centers,
	};
};

const mapDispatchToProps = {
	adminGetAllCampaigns,
	resetFocusCampaign,
	adminGetCampaignById,
	initNewCampaign,
	adminPostCampaign,
	adminPatchCampaign,
	adminDeleteCampaign,
	adminGetAnalysesPacksForCampaigns,
	searchDoctors,
	searchCompanies,
	getCampaignFileCsvToJson,
	adminGetAllCenters,
	getDoctorExists,
	getCsvTemplate,
	loadListRecords,
	getCampaignExport,
};

export default connect(mapStateToProps, mapDispatchToProps)(Campagnes);
